<template>
  <div class="project-trackings" v-if="trackings">
    <div class="statistics-global">
      <div class="page-header">
        <div class="title-grid">
          <h3>{{$t('statistics.latest_trackings')}}</h3>
          <relative-date-choser @change="dateChange" :choices="[1,7,30,60]"/>
        </div>
      </div>
      <div v-if="trackingsSorted.length > 0">
        <div v-for="trackings in trackingsSorted" :key="trackings[0].time" class="tracking-table">
          <div class="tracking-table--date">
            {{ moment(trackings[0].time).format('MMMM Do') }}
          </div>
          <tracking-table :project-id="id" :trackings="trackings"/>
        </div>
      </div>
      <div class="is-empty" v-else>
        {{$t('statistics.no_data')}}
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Tracking from '@/api/Tracking'
import RelativeDateChoser from '@/components/helpers/DataInput/RelativeDateChoser'

import TrackingTable from '@/components/pages/projects/TrackingTable'

export default {
  props: ['id'],
  components: { 
    TrackingTable,
    RelativeDateChoser
  },
  data(){
    return {
      trackings: null,
      trackingsSorted: [],
      moment,
      queryParams: {
        sort_by: 'time',
        sort_order: 'DESC'
      }
    }
  },
  mounted(){
    this.dateChange(1)
  },
  methods: {
    retrieveTrackings(){
      let params = Object.assign(this.queryParams, {project_id: this.id})
      let tracking = new Tracking()
      tracking.all(params).then((item) => {
        this.trackings = item
        this.initTrackings()
      })
    },
    dateChange(number){
      this.queryParams.end_date = moment().format()
      this.queryParams.start_date = moment().subtract(number,'d').format()
      this.trackings = []
      this.trackingsSorted = []
      this.retrieveTrackings()
    },
    initTrackings(){
      if(_.isEmpty(this.trackings.resources)){
        return true
      }
      // sort trackings
      this.trackings.resources.sort(function(a,b){
        let dateA = new Date(a.time)
        let dateB = new Date(b.time)
        if (dateA < dateB) return 1;
        else if(dateA > dateB) return -1;
        else return  0;
      });
      
      let currentTrackings = []
      this.trackings.resources.forEach((tracking, index) => {
        if(index == 0){
          currentTrackings.push(tracking)
          return
        }
        let currentDate = new Date(tracking.time)
        let lastDate = new Date(this.trackings.resources[index-1].time)

        if(this.sameDay(currentDate, lastDate)){
          currentTrackings.push(tracking)
        }else{
          this.trackingsSorted.push(currentTrackings)
          currentTrackings = [tracking]
        }

      });
      this.trackingsSorted.push(currentTrackings)
      console.log('trackings: ', this.trackings.resources)
      console.log('current trackings: ', currentTrackings)
      console.log('trackings sorted: ', this.trackingsSorted)
    },
    sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
    }
  }
}
</script>
<style lang="scss">
h3{
  margin-bottom: 15px;
}
.project-trackings{
  .page-header{
    margin-bottom: 25px;
  }
  a{
    color: #2e7bae;
  }
  h3{
    margin-bottom: 0px;
  }
  .title-grid{
    align-items: center;
    margin-bottom: 10px;
  }
  a{
      text-align: right;
      text-decoration: none;
    }
    .icon{
      font-size: 14px;
      vertical-align: sub;
    }
}
.tracking-table--date{
  color: #a09898;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// ProjectTrackingsFrame.vue?3349273c